import {AxiosRequestConfig} from 'axios';

export const getApiJsonBlobDataHeadersConfig = (): AxiosRequestConfig => ({
  headers: {
    'content-type': 'application/json',
  },
  responseType: 'blob',
});
